export default __webpack_public_path__ + "static/media/iso18001.755b098b.jpg";